import React from "react";
import LogLevelFilter from "./logLevelFilter";
import styles from "./toolbar.module.css";
import { Button } from "UiKit";
export default function TasksLogsToolbar({ title, onClear, levels, onLevelsChange, zIndex }) {
    return (React.createElement("div", { className: "v-center-items grid-cols-1fr-auto no-gap" },
        React.createElement("div", { className: "grid-cols-auto-1fr v-center-items no-gap", style: { alignItems: "center" } },
            React.createElement("div", { className: "font-bold nowrap text-overflow-ellipsis" }, title),
            React.createElement("div", { className: styles.actions },
                React.createElement(LogLevelFilter, { levels: levels, onLevelsChange: onLevelsChange, zIndex: zIndex }),
                onClear && (React.createElement(Button, { styleType: "text", size: "36", onClick: onClear, iconOnly: true },
                    React.createElement("i", { className: "icon-trash" })))))));
}
